import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import makeAnimated from 'react-select/animated';
import { useDispatch, useSelector } from "react-redux";
import { ReactSearchAutocomplete } from 'react-search-autocomplete'
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import { getAllState, saveState } from "../../../actions/StateAction";
import { getAllColor, saveColor } from "../../../actions/ColorActions";
import { getAllVehicleCode, saveVehicleCode } from "../../../actions/VehicleCodeActions";
import { getAllVehicleType, saveVehicleType } from "../../../actions/VehicleTypeActions";
import { getAllVehicleModel, saveVehicleModel } from "../../../actions/VehicleModelActions";
import { getAllVehicleMake, saveVehicleMake } from "../../../actions/VehicleMakeActions";
import { getAllVehicle, getVehicleById } from "../../../actions/VehicleActions";
import Toast from "../../../components/Toast";
import { investigationStyleSelect } from "../../../constants/customStyles";
import CreatableSelect from 'react-select/creatable';
import Dropzone, { useDropzone } from 'react-dropzone';
import { getAllAccidentType, saveAccidentType } from "../../../actions/AccidentTypeActions";
import { Swiper, SwiperSlide } from "swiper/react";
import { Grid, Scrollbar } from "swiper";
import SignatureCanvas from 'react-signature-canvas'

const Step2 = (props) => {

    const dispatch = useDispatch();

    const { data, handleChange, next, setFormData, formData, back, handleChangeDropdown, customerVehicles, handleChangeAccidentSide, handleChangeVehicleType, vehicleModelByMakeId, handleChangeVehicleCode, handleChangeVehicleMake, handleChangeVehicleColor, handleChangeVehicleState, handleChangeVehicleModel, files, setFiles } = props;

    useEffect(() => {
        if (data && Object.keys(data).length > 0) {
            setFormData({
                ...formData,
                'vehicle_id': data?.vehicle?.vehicle_id,
                'chasis_no': data?.vehicle?.chasis_no,
                'plate_number': data?.vehicle?.plate_number,
                'vehicle_type_id': data?.vehicle?.vehicle_type_id,
                'vehicle_type_name': data?.vehicle?.vehicle_type?.name,
                'code_id': data?.vehicle?.code_id,
                'vehicle_code_name': data?.vehicle?.vehicle_code?.name,
                'vehicle_make_id': data?.vehicle?.vehicle_make_id,
                'vehicle_make_name': data?.vehicle?.vehicle_make?.name,
                'vehicle_model_id': data?.vehicle?.vehicle_model_id,
                'vehicle_model_name': data?.vehicle?.vehicle_model?.name,
                'color_id': data?.vehicle?.color_id,
                'vehicle_color_name': data?.vehicle?.color?.name,
                'state_id': data?.vehicle?.state_id,
                'vehicle_state_name': data?.vehicle?.state?.name,
                'registration_expiry': data?.reg_expiry,
                'service_date': data?.service_date,
                'service_mile': data?.service_mile,
                'accident_side': data?.accident_side,
                'repair_time': data?.repair_time,
                'note': data?.note,
                'vehicle_graph': data?.vehicle_graph?.vehicle_graph,
                'fuel_level': data?.vehicle_graph?.fuel_level,
            });
            loadSignatureFromBase64(data?.vehicle_graph?.vehicle_graph);
            dispatch(getVehicleById(data.vehicle_id))
        }
    }, [data])

    const [stateId, setStateId] = useState('');
    const [color, setColor] = useState('');
    const [vehicleCode, setVehicleCode] = useState('');
    const [vehicleType, setVehicleType] = useState('');
    const [vehicleModel, setVehicleModel] = useState('');
    const [plateNo, setPlateNo] = useState('');
    const [chasisNo, setChasisNo] = useState('');
    const [regExpiry, setRegExpiry] = useState('');
    const [serviceExpiry, setServiceExpiry] = useState('');
    const [repairTime, setRepairTime] = useState('');
    const [serviceMile, setServiceMile] = useState('');
    const [accidentSide, setAccidentSide] = useState('');
    const [note, setNote] = useState('');
    const [selectedState, setSelectedState] = useState('');
    const [selectedCode, setSelectedCode] = useState('');
    const [selectedVehicleType, setSelectedVehicleType] = useState('');
    const [selectedVehicleMake, setSelectedVehicleMake] = useState('');
    const [selectedVehicleModel, setSelectedVehicleModel] = useState('');
    const [selectedVehicleColor, setSelectedVehicleColor] = useState('');
    const [searchString, setSearchString] = useState('');

    useEffect(() => {
        dispatch(getAllState(null, 9999, { status: 1 }));
        dispatch(getAllColor(null, 9999, { status: 1 }));
        dispatch(getAllVehicleCode(null, 9999, { status: 1 }));
        dispatch(getAllVehicleType(null, 9999, { status: 1 }));
        dispatch(getAllVehicleModel(null, 9999, { status: 1 }));
        dispatch(getAllVehicleMake(null, 9999, { status: 1 }));
        dispatch(getAllVehicle(null, 9999, { status: 1 }));
        dispatch(getAllAccidentType(null, 9999, { status: 1 }));
    }, []);

    const state = useSelector(state => state?.state?.states?.data);
    const colors = useSelector(state => state?.color?.colors?.data);
    const vehicleTypes = useSelector(state => state?.vehicleType?.vehicleTypes?.data);
    const vehicleModels = useSelector(state => state?.vehicleModel?.vehicleModels?.data);
    const vehicleCodes = useSelector(state => state?.vehicleCode?.vehicleCodes?.data);
    const vehicleMaker = useSelector(state => state?.vehicleMaker?.vehicleMakers?.data);
    // 'vehicleMaker', vehicleMaker)
    const vehicles = useSelector(state => state?.vehicle?.vehicles?.data);
    const vehicle = useSelector(state => state?.vehicle?.vehicle);
    const accidentTypes = useSelector(state => state?.accidentTypes?.accidentTypes?.data);


    // 'vehicle11212', vehicle)

    const save = () => {
        if (plateNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Plate No is Required!'
            })
        } else if (chasisNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Chasis No. is Required!'
            })
        } else if (regExpiry.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Reg. Expiry is Required!'
            })
        } else if (serviceExpiry.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Service Expiry is Required!'
            })
        } else if (serviceMile.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Service KM is Required!'
            })
        } else if (repairTime.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Repair Time is Required!'
            })
        } else if (accidentSide.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Accident Side is Required!'
            })
        } else if (stateId.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'State is Required!'
            })
        } else if (vehicleCode.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Code is Required!'
            })
        } else if (color.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Color is Required!'
            })
        } else if (vehicleType.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Type is Required!'
            })
        } else if (vehicleModel.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Vehicle Model is Required!'
            })
        } else {
            let data = {
                plate_number: plateNo,
                chasis_no: chasisNo,
                registration_expiry: regExpiry,
                service_date: serviceExpiry,
                service_mile: serviceMile,
                note: note,
                state_id: stateId,
                code_id: vehicleCode,
                color_id: color,
                vehicle_type_id: vehicleType,
                vehicle_model_id: vehicleModel,
            }
            // dispatch(saveVehicle(data));
        }
        // window.location.href = ('/vehicleType');
    }

    const handleOnSearch = (string) => {
        setSearchString(string);
        setFormData({
            ...formData,
            chasis_no: string,
        });
        // onSearch will have as the first callback parameter
        // the string searched and for the second the results.
        // 'test' , string, results)
        // vehicles)
        // setFormData({
        //     ...formData,
        //     'chasis_no': string,
        // });
        // let formDataState = formData;
        // formDataState);
    }

    let filteredData = '';
    if (vehicles && Object.keys(vehicles).length > 0) {
        filteredData = vehicles.filter((item) => {
            // Convert the item to a string and make it lowercase for case-insensitive search
            const itemString = JSON.stringify(item).toLowerCase();
            // Check if the itemString includes the searchQuery
            return itemString.includes(searchString.toLowerCase());
        });
    }

    const handleOnSelect = (item) => {
        setFormData({
            ...formData,
            'chasis_no': item.chasis_no,
            'plate_number': item.plate_number,
            'vehicle_type_id': item.vehicle_type_id,
            'code_id': item.code_id,
            'vehicle_make_id': item.vehicle_make_id,
            'vehicle_model_id': item.vehicle_model_id,
            'color_id': item.color_id,
            'state_id': item.state_id,
            'vehicle_type_name': item?.vehicle_type?.name,
            'vehicle_code_name': item?.vehicle_code?.name,
            'vehicle_make_name': item?.vehicle_make?.name,
            'vehicle_model_name': item?.vehicle_model?.name,
            'vehicle_color_name': item?.color?.name,
            'vehicle_state_name': item?.state?.name,
        });
        dispatch(getVehicleById(item.vehicle_id))
    }
    // 'vehicle',vehicles)
    const handleOnClear = () => {
        setFormData({
            ...formData,
            'chasis_no': "",
            'plate_number': "",
            'vehicle_type_id': "",
            'code_id': "",
            'vehicle_make_id': "",
            'vehicle_model_id': "",
            'color_id': "",
            'state_id': "",
            'vehicle_type_name': "",
            'vehicle_code_name': "",
            'vehicle_make_name': "",
            'vehicle_model_name': "",
            'vehicle_color_name': "",
            'vehicle_state_name': "",
        });
        // dispatch(getVehicleById(item.vehicle_id))
    }
    const customStyles = {
        headRow: {
            style: {
                border: 'none !important'
            }
        },
        head: {
            style: {
                fontWeight: 'bold',
                fontSize: '14px',
                border: 'none !important',
            }
        },
        rows: {
            style: {
                minHeight: '60px', // override the row height
                backgroundColor: 'rgb(250, 250, 250)',
                borderTop: 'none !important',
                marginBottom: '10px',
                borderRadius: '30px',
                paddingRight: '5px',
                '&:not(:last-of-type)': {
                    border: 'none'
                }
            },
        },
        headCells: {
            style: {
                paddingLeft: '20px', // override the cell padding for head cells
                paddingRight: '20px',
                fontSize: '14px',
                fontWeight: '700',
                textTransform: 'uppercase',
                border: 'none !important',
            },
        },
        cells: {
            style: {

                fontSize: '14px',
                // 'div:first-child': {
                //     overflow: 'visible !important'
                // }
                // justifyContent: 'center'
            },
        },
        pagination: {
            style: {
                borderTop: 'none !important',
            },
        }
    };

    const columns = [
        {
            name: 'VEHICLE CODE',
            selector: row => row?.vehicle_code?.name,
        },
        {
            name: 'PLATE NO.',
            selector: row => row?.plate_number,
        },
        {
            name: 'VEHICLE STATE',
            selector: row => row?.state?.name,
        },
        {

            selector: row => <button data-bs-dismiss="modal" className="btn btn-success me-5 text-white" onClick={() => handleOnSelect(row)}> Add </button>
        },
    ];

    const [isLoading, setIsLoading] = useState(false);
    // const [options, setOptions] = useState(defaultOptions);

    const handleCreateState = (inputValue) => {
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveState(data));
            dispatch(getAllState(null, 9999));
        }, 1000);
        const newOption = {
            id: 'new', // Unique identifier for the new option
            name: inputValue, // The name of the new option
        };
        setFormData({
            state_id: newOption.id,
            vehicle_state_name: newOption.name,
        });
    }
    const handleCreateVehicleCode = (inputValue) => {
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleCode(data));
            dispatch(getAllVehicleCode(null, 9999));
        }, 1000);
        const newOption = {
            id: 'new', // Unique identifier for the new option
            name: inputValue, // The name of the new option
        };
        setFormData({
            code_id: newOption.id,
            vehicle_code_name: newOption.name,
        });
    }
    const handleCreateVehicleType = (inputValue) => {
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleType(data));
            dispatch(getAllVehicleType(null, 9999));
        }, 1000);
        const newOption = {
            id: 'new', // Unique identifier for the new option
            name: inputValue, // The name of the new option
        };
        setFormData({
            vehicle_type_id: newOption.id,
            vehicle_type_name: newOption.name,
        });
    }
    const handleCreateVehicleMake = (inputValue) => {
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveVehicleMake(data))
            dispatch(getAllVehicleMake(null, 9999))
        }, 1000);
        const newOption = {
            id: 'new', // Unique identifier for the new option
            name: inputValue, // The name of the new option
        };
        setFormData({
            vehicle_make_id: newOption.id,
            vehicle_make_name: newOption.name,
        });
    }
    const handleCreateVehicleModel = (inputValue) => {
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
                vehicle_make_id: formData?.vehicle_make_id ? formData?.vehicle_make_id : '',
            }
            await dispatch(saveVehicleModel(data));
            dispatch(getAllVehicleModel(null, 9999));
        }, 1000);
        const newOption = {
            id: 'new', // Unique identifier for the new option
            name: inputValue, // The name of the new option
        };
        setFormData({
            vehicle_model_id: newOption.id,
            vehicle_model_name: newOption.name,
        });
    }
    const handleCreateVehicleColor = (inputValue) => {
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveColor(data));
            dispatch(getAllColor(null, 9999));
        }, 1000);
        const newOption = {
            id: 'new', // Unique identifier for the new option
            name: inputValue, // The name of the new option
        };
        setFormData({
            color_id: newOption.id,
            vehicle_color_name: newOption.name,
        });
    }

    const handleCreateAccidentType = (inputValue) => {
        // inputValue)
        setIsLoading(true);
        setTimeout(async () => {
            setIsLoading(false);
            // createOption(inputValue);
            let data = {
                name: inputValue,
            }
            await dispatch(saveAccidentType(data));
            dispatch(getAllAccidentType(null, 9999));
        }, 1000, []);
        const newOption = {
            id: 'new', // Unique identifier for the new option
            name: inputValue, // The name of the new option
        };
        setFormData({
            ...formData,
            accident_side: newOption.name,
        });
    }
    const [vehicleModelOptions, setVehicleModelOptions] = useState('');

    useEffect(() => {
        if (vehicleModelByMakeId && vehicleModelByMakeId.length > 0) {
            setVehicleModelOptions(vehicleModelByMakeId)
        } else {
            setVehicleModelOptions(vehicleModels)
        }
    }, [vehicleModelByMakeId, vehicleModels])



    const thumbsContainer = {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        margin: 16
    };

    const thumb = {
        display: 'inline-flex',
        borderRadius: 2,
        border: '1px solid #eaeaea',
        marginBottom: 8,
        marginRight: 15,
        width: 100,
        height: 100,
        padding: 4,
        boxSizing: 'border-box'
    };

    const thumbInner = {
        display: 'block',
        minWidth: 92,
        overflow: 'hidden'
    };

    const img = {
        display: 'block',
        width: 'auto',
        height: '100%'
    };

    const { getRootProps, getInputProps } = useDropzone({
        maxFiles: 30,
        accept: '.jpeg,.png,.jpg',
        maxSize: 5000000,
        onDropAccepted: acceptedFiles => {
            if (files && files.length == 1) {
                setFiles(files.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                    preview: URL.createObjectURL(file),
                    default: (index == 0) ? 1 : 0
                }))));
            } else {
                if (acceptedFiles.length + files.length > 30) {
                    Toast.fire({
                        icon: 'error',
                        title: 'Maximum 30 Images Allowed',
                    });
                } else {
                    setFiles(files.concat(acceptedFiles.map((file, index) => Object.assign(file, {
                        preview: URL.createObjectURL(file),
                        default: 0
                    }))));
                }
            }
        },
        onDropRejected: rejectedFiles => {
            if (rejectedFiles.length > 0) {
                let error = 'There was an error';
                if (rejectedFiles[0].errors[0].code == 'file-invalid-type') {
                    error = 'File Format Not Supported';
                } else if (rejectedFiles[0].errors[0].code == 'file-too-large') {
                    error = 'Image Size greater than 5mb'
                } else if (rejectedFiles[0].errors[0].code == 'too-many-files') {
                    error = 'Maximum 30 Images Allowed';
                }
                // setDropzoneError(rejectedFiles[0].errors[0].message);
                Toast.fire({
                    icon: 'error',
                    title: error,
                });
            }
        }
    });
    const removeImage = (file, index) => {
        const updatedFiles = [...files];

        if (index === 0 && file.default === 1) {
            updatedFiles[1].default = 1;
        } else if (index !== 0 && file.default === 1) {
            updatedFiles[0].default = 1;
        }
        let imageIds = [];
        if (updatedFiles[index].id) {

            imageIds = [updatedFiles[index].id];

            setFormData({
                ...formData,
                imageId: imageIds
            });


        }
        updatedFiles.splice(index, 1);

        setFiles(updatedFiles);
    }
    const [dropzoneTitle, setDropZoneTitle] = useState("Please Upload Photos");


    const thumbs = files.length > 0 && files.map((file, index) => {
        return (
            <React.Fragment key={index + 1}>
                <SwiperSlide>
                    <div>
                        <div style={thumb} className={`${file.default == 1 ? "default-image" : ''}`} key={file.name}>
                            <div style={thumbInner}>
                                <img
                                    src={file.preview}
                                    style={img}
                                />
                            </div>
                        </div>
                        <span class="image-close" onClick={() => removeImage(file, index)}>&times;</span>
                    </div>
                </SwiperSlide>
            </React.Fragment>
        )
    }
    );

    const currentYear = new Date().getFullYear();
    const yearOptions = Array.from({ length: 100 }, (_, index) => ({
        label: (currentYear - index).toString(),
        value: (currentYear - index).toString(),
    }));


    const FuelOptions = [
        { label: 'F', value: 'F' },
        { label: '95%', value: '95%' },
        { label: '90%', value: '90%' },
        { label: '85%', value: '85%' },
        { label: '80%', value: '80%' },
        { label: '75%', value: '75%' },
        { label: '70%', value: '70%' },
        { label: '65%', value: '65%' },
        { label: '60%', value: '60%' },
        { label: '55%', value: '55%' },
        { label: '50%', value: '50%' },
        { label: '45%', value: '45%' },
        { label: '40%', value: '40%' },
        { label: '35%', value: '35%' },
        { label: '30%', value: '30%' },
        { label: '25%', value: '25%' },
        { label: '20%', value: '20%' },
        { label: '15%', value: '15%' },
        { label: '10%', value: '10%' },
        { label: '5%', value: '5%' },
        { label: 'E', value: 'E' },
    ];

    const [fuel, setFuel] = useState('');

    const handleChangFuel = (e) => {
        // e)
        setFormData({
            ...formData,
            'fuel_level': e.value
        });
    };

    const signatureRef = useRef(null);

    const clearCanvas = () => {
        signatureRef.current.clear(); // Clear the canvas
        const base64Data = signatureRef.current.toDataURL();
        setFormData({
            ...formData,
            'vehicle_graph': base64Data
        });
        console.log(base64Data);
    };

    const getVehicleGraph = () => {
        if (signatureRef.current) {
            signatureRef.current.getCanvas().style.width = '370px';
            signatureRef.current.getCanvas().style.height = '250px';
            // Use toDataURL() without trimming to preserve exact positions
            const base64Data = signatureRef.current.toDataURL();
            setFormData({
                ...formData,
                'vehicle_graph': base64Data
            });
        } else {
            console.error("SignatureCanvas is not available yet.");
        }
    };

    const loadSignatureFromBase64 = (base64String) => {
        if (signatureRef.current && base64String) {
            // Clear the current canvas before loading the new data
            signatureRef.current.clear();

            // Create an image to load base64 and adjust scaling
            const img = new Image();
            img.src = base64String;
            img.onload = () => {
                const canvas = signatureRef.current.getCanvas();
                const ctx = canvas.getContext('2d');
                ctx.clearRect(0, 0, canvas.width, canvas.height); // Clear the canvas

                // Ensure the canvas size matches original
                canvas.width = 370;
                canvas.height = 250;

                // Draw the base64 image onto the canvas, adjusting for any offset
                ctx.drawImage(img, 0, 0, 370, 250);
            };
        }
    };
    // const loadSignatureFromBase64 = (base64String) => {
    //     if (signatureRef.current && base64String) {
    //         // Clear the current canvas before loading the new data
    //         signatureRef.current.clear();

    //         // Load the base64 image into the canvas
    //         signatureRef.current.fromDataURL(base64String);

    //         // Make sure the canvas has the exact same size it had during drawing
    //         signatureRef.current.getCanvas().style.width = '370px';
    //         signatureRef.current.getCanvas().style.height = '250px';
    //     }
    // };

    return (
        <>
            <div className="d-flex align-items-center mt-8">
                <h2 className="intro-y fs-lg fw-medium me-auto">
                    Investigation
                </h2>
            </div>
            <div className="intro-y box py-10 py-sm-20 mt-5">
                <div className="wizard d-flex flex-column flex-lg-row justify-content-center px-8">
                    <div className="intro-x text-lg-center d-flex align-items-center d-lg-block flex-1 z-10">
                        <button className="w-12 h-12 rounded-circle fs-lg btn btn-primary">1</button>
                        <div className="w-lg-40 fw-medium fs-lg mt-lg-3 ms-3 mx-lg-auto">Customer Details</div>
                    </div>
                    <div className="intro-x text-lg-center d-flex align-items-center mt-5 mt-lg-0 d-lg-block flex-1 z-10">
                        <button className="w-12 h-12 rounded-circle fs-lg btn btn-primary">2</button>
                        <div className="w-lg-40 fw-medium fs-lg mt-lg-3 ms-3 mx-lg-auto">Vehicle Details</div>
                    </div>
                    <div className="intro-x text-lg-center d-flex align-items-center mt-5 mt-lg-0 d-lg-block flex-1 z-10">
                        <button className="w-12 h-12 rounded-circle fs-lg btn text-gray-600 bg-gray-200 dark-bg-dark-1">3</button>
                        <div className="w-lg-40 fs-lg mt-lg-3 ms-3 mx-lg-auto text-gray-700 dark-text-gray-600">Products Added</div>
                    </div>
                    <div className="wizard__line d-none d-lg-block w-2/3 bg-gray-200 dark-bg-dark-1 position-absolute mt-5"></div>
                </div>
                <div className="px-5 px-sm-20 mt-10 pt-10 border-top border-gray-200 dark-border-dark-5">
                    <div className="grid columns-12">
                        <div className="g-col-12 g-col-lg-8 g-col-md-8 g-col-sm-12">
                            <div className="d-flex align-items-center justify-content-between">
                                <div className="fw-medium fs-base">Vehicle Details:</div>
                                {
                                    customerVehicles &&
                                        customerVehicles.length > 0 ?
                                        <button className="btn btn-primary" data-bs-target="#vehicle-modal" data-bs-toggle="modal">Pick Vehicle</button>
                                        :
                                        <button className="btn btn-primary" disabled data-bs-target="#vehicle-modal" data-bs-toggle="modal">Pick Vehicle</button>
                                }
                            </div>
                            <div className="grid columns-12 gap-4 gap-y-5 mt-5">
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="states" className="form-label">States<span className="text-theme-6">*</span> :</label>
                                    <CreatableSelect formatCreateLabel={() => "Create New.."} isValidNewOption={() => false} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateState} styles={investigationStyleSelect} name="state_id"
                                        value={formData?.state_id ? { id: formData?.state_id, name: formData?.vehicle_state_name } : null} onChange={(e) => handleChangeVehicleState('state_id', e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.state_id}`} options={state && state.length > 0 ? state : []} />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="code" className="form-label">Code<span className="text-theme-6">*</span> :</label>
                                    <CreatableSelect formatCreateLabel={() => "Create New.."} isValidNewOption={() => false} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleCode} name="code_id"
                                        value={formData?.code_id ? { id: formData?.code_id, name: formData?.vehicle_code_name } : formData.code_id} styles={investigationStyleSelect} onChange={(e) => handleChangeVehicleCode('code_id', e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.vehicle_code_id}`} options={vehicleCodes && vehicleCodes.length > 0 ? vehicleCodes : []} />
                                    {/* <Select name="vehicle_code_id" value={formData?.code_id ? { id: formData?.code_id, name: formData?.vehicle_code_name } : formData.code_id} styles={investigationStyleSelect} onChange={(e) => handleChangeVehicleCode('code_id', e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.vehicle_code_id}`} options={vehicleCodes && vehicleCodes.length > 0 ? vehicleCodes : []} /> */}
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="chasis_no" className="form-label">Chasis No<span className="text-theme-6">*</span> :</label>
                                    <ReactSearchAutocomplete
                                        items={vehicles && vehicles.length > 0 ? vehicles : []}
                                        onSearch={handleOnSearch}
                                        // onHover={handleOnHover}
                                        inputDebounce={0}
                                        inputSearchString={formData?.chasis_no}
                                        onSelect={handleOnSelect}
                                        // onFocus={handleOnFocus}
                                        styling={{
                                            backgroundColor: '.auto-input:focus' ? '#fff' : '#fff',
                                            border: '.auto-input:focus' ? '1px solid #e2e8f0' : '1px solid #e2e8f0',
                                            borderColor: '.auto-input:focus' ? '#e2e8f0' : '#e2e8f0 !important',
                                            boxShadow: '.auto-input:focus' ? '0 0 0 0.25rem rgba(28, 63, 170, .25)' : '0 1px 2px 0 rgba(0, 0, 0, .05)',
                                            color: '.auto-input:focus' ? '#2d3748' : '#2d3748',
                                            borderRadius: '0.375rem',
                                            '&:hover': { borderColor: '#e2e8f0' }
                                        }}
                                        // inputSearchString={formData && formData.chasis_no && formData?.chasis_no ? formData?.chasis_no : null}
                                        className="auto-input"
                                        // autoFocus
                                        fuseOptions={{ keys: ["vehicle_id", "chasis_no"] }}
                                        resultStringKeyName={"chasis_no"}
                                        // inputSearchString="mobile"
                                        autoComplete={false}
                                        onClear={handleOnClear}
                                    // value={vehicle?.chasis_no}
                                    // value={formData?.chasis_no ? formData?.chasis_no : 'fail')}
                                    // value={formData?.chasis_no ? {id: vehicle?.vehicle_id, name: vehicle?.chasis_no} : 'test'}
                                    // formatResult={formatResult}
                                    />
                                    {/* <input id="chasis_no" name="vehcile_chasis_no" type="text" className="form-control h-45px" onChange={handleChange} placeholder="Enter Chasis No." /> */}
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="plate_no" className="form-label">Plate No<span className="text-theme-6">*</span> :</label>
                                    <input id="plate_no" value={formData?.plate_number} name="plate_number" type="text" className="form-control h-45px" onChange={handleChange} placeholder="Enter Plate No." />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="vehicle_type" className="form-label">Vehicle Type<span className="text-theme-6">*</span> :</label>
                                    {/* <Select name="vehcile_registration_expiry" styles={investigationStyleSelect} onChange={(e) => setVehicleType(e.vehicle_type_id)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.vehicle_type_id}`} options={vehicleTypes.length > 0 ? vehicleTypes : []} /> */}
                                    {
                                        // 'vehicle test', vehicle)
                                    }
                                    <CreatableSelect isValidNewOption={() => false} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleType} name="vehicle_type_id"
                                        value={formData?.vehicle_type_id ? { id: formData?.vehicle_type_id, name: formData?.vehicle_type_name } : formData.vehicle_type_id} styles={investigationStyleSelect} onChange={(e) => handleChangeVehicleType('vehicle_type_id', e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.vehicle_type_id}`} options={vehicleTypes && vehicleTypes.length > 0 ? vehicleTypes : []} />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="vehicle_model" className="form-label">Vehicle Make<span className="text-theme-6">*</span> :</label>
                                    <CreatableSelect isValidNewOption={() => false} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleMake} name="vehicle_make_id"
                                        value={formData?.vehicle_make_id ? { id: formData?.vehicle_make_id, name: formData?.vehicle_make_name } : formData.vehicle_make_id} styles={investigationStyleSelect} onChange={(e) => handleChangeVehicleMake('vehicle_make_id', e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.vehicle_make_id}`} options={vehicleMaker && vehicleMaker.length > 0 ? vehicleMaker : []} />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="vehicle_model" className="form-label">Vehicle Model<span className="text-theme-6">*</span> :</label>
                                    {/* <input type="number" name="year" id="" className="form-control" placeholder="Enter Year" min={1900} max={2100} /> */}
                                    <CreatableSelect isValidNewOption={() => false} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleModel} name="vehicle_model_id"
                                        value={formData?.vehicle_model_id ? { id: formData?.vehicle_model_id, name: formData?.vehicle_model_name } : formData.vehicle_model_id}
                                        styles={investigationStyleSelect} onChange={(e) => handleChangeVehicleModel(e)}
                                        getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.vehicle_model_id}`}
                                        options={vehicleModelOptions && vehicleModelOptions.length > 0 ? vehicleModelOptions : []} />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="color" className="form-label">Color<span className="text-theme-6">*</span> :</label>
                                    <CreatableSelect isValidNewOption={() => false} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateVehicleColor} styles={investigationStyleSelect}
                                        name="color_id" value={formData?.color_id ? { id: formData?.color_id, name: formData?.vehicle_color_name } : null} onChange={(e) => handleChangeVehicleColor('color_id', e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.color_id}`} options={colors && colors.length > 0 ? colors : []} />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="repair_time" className="form-label">Repair Time :</label>
                                    <input id="repair_time" onChange={handleChange} value={formData?.repair_time} name="repair_time" type="text" className="form-control h-45px" placeholder="Enter Repair Time" />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="reg_expiry" className="form-label">Reg. Expiry:</label>
                                    <input id="reg_expiry" onChange={handleChange} value={formData?.registration_expiry} name="registration_expiry" type="date" className="form-control h-45px" placeholder="Enter Reg. Expiry" />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="service_date" className="form-label">Service Date:</label>
                                    <input id="service_date" onChange={handleChange} value={formData?.service_date} min={new Date().toISOString().split('T')[0]} name="service_date" type="date" className="form-control h-45px" placeholder="Enter Service Date" />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="serviceMile" className="form-label">Service KM :</label>
                                    <input id="serviceMile" onChange={handleChange} value={formData?.service_mile} name="service_mile" type="text" className="form-control h-45px" placeholder="Enter Sevice Mile" />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="accident_side" className="form-label">Accident Side :</label>
                                    {/* <input id="accident_side" onChange={handleChange} value={formData?.accident_side} name="accident_side" type="text" className="form-control h-45px" placeholder="Enter Accident Side" /> */}
                                    <CreatableSelect isValidNewOption={() => false} formatCreateLabel={() => "Create New.."} getNewOptionData={(inputValue, optionLabel) => ({ id: 'new', name: 'Create ' + '"' + inputValue + '"', })}
                                        isDisabled={isLoading} isLoading={isLoading} onCreateOption={handleCreateAccidentType} value={formData?.accident_side ? { id: formData?.accident_side, name: formData?.accident_side } : formData?.accident_side}
                                        onChange={(e) => handleChangeAccidentSide('accident_side', e)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.id}`}
                                        options={accidentTypes && accidentTypes.length > 0 ? accidentTypes : []} styles={investigationStyleSelect} placeholder="Select Accident Type" />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="note" className="form-label">Note:</label>
                                    <textarea id="note" value={formData?.note} name="note" type="text" rows={8} className="form-control" onChange={handleChange} placeholder="Enter Note" />
                                </div>
                                <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                                    <label for="image" className="form-label">Image:</label>
                                    <section className="text-center form-control w-full">
                                        <aside style={thumbsContainer} className="justify-content-center mb-0">
                                            {
                                                (files.length == 0) &&
                                                <p className="dropz-title fs-base text-gray-500">Please upload Images</p>
                                            }
                                        </aside>
                                        <Swiper
                                            slidesPerView={3}
                                            scrollbar={{
                                                hide: true,
                                            }}
                                            grid={{
                                                rows: 1,
                                            }}
                                            modules={[Grid, Scrollbar]}
                                            className="mySwiper h-full"
                                        >
                                            {thumbs}
                                        </Swiper>
                                        <div {...getRootProps({ className: 'dropzone p-2' })}>
                                            <input {...getInputProps()} />
                                            <hr className="border border-gray-200 bg-gray-300 border-dashed" />
                                            <div className="btn btn-primary w-25 mt-3">Upload Photos</div>
                                        </div>
                                    </section>
                                </div>
                            </div>
                        </div>
                        <div className="intro-y g-col-12 g-col-lg-4 g-col-md-4 g-col-sm-12">
                            <div className="d-flex align-items-center justify-content-between">
                                <label for="signature" className="form-label">Vehicle Graph <span className="text-theme-6">*</span> :</label>
                                <button className="btn btn-outline-secondary mb-2" onClick={clearCanvas}>Clear</button>
                            </div>
                            <div className="border border-gray-300 rounded-2 canvas-bg" style={{ width: 370, height: 250 }}>
                                <SignatureCanvas
                                    penColor='red'
                                    onEnd={getVehicleGraph}
                                    ref={(ref) => (signatureRef.current = ref)}
                                    onKeyPress={clearCanvas}
                                    canvasProps={{ width: 370, height: 250, className: 'signatureCanvas' }}
                                />
                            </div>
                            <label for="crud-form-1" className="form-label mt-3">Fuel <span className="text-theme-6">*</span> :</label>
                            <Select styles={investigationStyleSelect} className="z-50" value={{ label: formData?.fuel_level, value: formData?.fuel_level }} options={FuelOptions} id="repalcedVehicleFuelId" name="replacedVehicleFuelOut" onChange={(e) => handleChangFuel(e)} />
                        </div>

                        {/* <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                            <label for="job_type" className="form-label">Job Type :</label>
                            <Select isMulti styles={investigationStyleSelect} options={Options} components={animatedComponents} />
                        </div>
                        <div className="intro-y g-col-12 g-col-lg-4 g-col-md-6 g-col-sm-6">
                            <label for="job_category" className="form-label">Job Category :</label>
                            <Select isMultis styles={investigationStyleSelect} options={Options} components={animatedComponents} />
                        </div> */}
                        <div className="intro-y g-col-12 d-flex align-items-center justify-content-center justify-content-sm-end mt-5">
                            <button className="btn btn-secondary w-24" onClick={back}>Previous</button>
                            <button className="btn btn-primary w-24 ms-2" onClick={next}>Next</button>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- BEGIN: Modal Content --> */}
            <div id="vehicle-modal" class="modal fade" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-body p-0"> <a data-bs-dismiss="modal" href="javascript:;" class="position-absolute end-0 top-0 mt-3 me-3"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x w-8 h-8"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg> </a>
                            <div class="p-5 text-center"> <i data-feather="check-circle" class="w-16 h-16 text-theme-9 mx-auto mt-3"></i>
                                <div class="fs-xl text-primary border-bottom border-gray-400 fw-medium p-4">Pick Vehicle</div>
                                <DataTable
                                    className="overflow-visible"
                                    columns={columns.map(column => ({
                                        ...column,
                                        cell: column.cell ? column.cell : (row) => (
                                            <div>
                                                {column.selector(row)}
                                            </div>
                                        ),
                                    }))}
                                    data={customerVehicles && customerVehicles.length > 0 ? customerVehicles : []}
                                    striped={true}
                                    highlightOnHover={true}
                                    pagination={true}
                                    customStyles={customStyles}
                                    responsive={true}
                                    paginationServer={false} // Set to false for frontend pagination
                                    paginationPerPage={10} // Set default rows per page
                                    paginationRowsPerPageOptions={[10, 20, 50, 100]} // Options for rows per page
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* <!-- END: Modal Content --> */}
        </>
    );
};
export default Step2;